import { observer } from 'mobx-react'
import React, { ReactElement } from 'react'

import { removeSearchAndMonitoringConfig } from '@flowwai-frontend/bps-officer-web/common/data-access'
import {
   ConfirmationCard,
   ConfirmationModal,
   showCRMFailureToastWithGivenMessage
} from '@flowwai-frontend/bps-officer-web/common/ui'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { useCustomT } from '@flowwai-frontend/shared/common-components'
import { AlertTriangleFeaturedIcon } from '@flowwai-frontend/design-system/icons'
import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

import { useLogoutAPI } from '../../hooks/apis/useLogoutAPI'

interface LogoutControllerProps {
   isLogoutModalOpen: boolean
   setIsLogoutModalOpen: (isLogoutModalOpen: boolean) => void
}

const LogoutController = (props: LogoutControllerProps): ReactElement => {
   const { isLogoutModalOpen, setIsLogoutModalOpen } = props

   const t = useCustomT('auth:logout')

   const { logout, logoutAPIStatus } = useLogoutAPI()
   const { theme } = useAppTheme()

   const logoutTheme = theme.auth.logout

   const onSuccess = (): void => {
      closeLogoutModal()
      removeSearchAndMonitoringConfig()
   }

   const closeLogoutModal = (): void => {
      setIsLogoutModalOpen(false)
   }

   const onFailure = (): void => {
      showCRMFailureToastWithGivenMessage(t('errorMessage'))
   }

   const logoutAPI = (): void => {
      logout({ client_id: Config.LOGIN_CLIENT_ID }, onSuccess, onFailure)
   }

   const renderConfirmationCard = () => (
      <ConfirmationCard
         heading={t('title')}
         description={t('description')}
         onDelete={logoutAPI}
         apiStatus={logoutAPIStatus}
         closeModal={closeLogoutModal}
         cancelButtonText={t('cancelText')}
         confirmButtonText={t('confirmText')}
         renderIcon={() => (
            <AlertTriangleFeaturedIcon
               fill={logoutTheme.alertIconColor}
               outerBgColor={logoutTheme.alertOuterIconBgColor}
               innerBgColor={logoutTheme.alertInnerIconBgColor}
            />
         )}
      />
   )

   return (
      <ConfirmationModal
         onCloseModal={closeLogoutModal}
         isOpen={isLogoutModalOpen}
         renderConfirmationCard={renderConfirmationCard}
         apiStatus={logoutAPIStatus}
      />
   )
}

export default observer(LogoutController)
